import { useState } from "react";

import { t } from "i18next";

import DeleteIcon from "../../shared/Icons/DeleteIcon";
import UploadIcon from "../../shared/Icons/UploadIcon";
import Typography from "../../shared/typography/Typography";
import { FileUploadButton } from "../FIleUploadButton";

import { Container, Header, Content, ActionsContainer, FileName, UploadedImage} from "./style";

import { getFileSizeStr } from "../utils/getFileSize";
import { breakpointSize } from "../../../theme/mediaQuerie";

export interface IFile {
  file: File;
  name: string;
  url: string;
}

interface IProps {
  file: IFile | null;
  setFile: React.Dispatch<IFile | null>;
  title: string;
  maxImageSize: number; // in bytes
  id: string;
  style?: React.CSSProperties;
}

const isMobile = window.innerWidth <= breakpointSize.Sm;

export const UploadImage = ({title, maxImageSize, file, setFile, id, style}: IProps) => {
  const messageBanner = t('event.dashboard.image.format', {maxImageSize: getFileSizeStr(maxImageSize)});

  const [message, setMessage] = useState(messageBanner);
  const [hasError, setHasError] = useState(false);

  const checkFileFormat = (file: File) => {
    const acceptedTypes = ["svg", "png", "jpg", "jpeg"];
    const fileType = file.type.replace("image/", "");
    if (!acceptedTypes.includes(fileType)) {
      setMessage(t('dashboard.image.error.format')!);
      return false;
    }
    return true;
  };

  const checkFileSize = (file: File) => {
    if (file.size > maxImageSize) {
      setMessage(t('event.dashboard.image.error.size', {maxImageSize: getFileSizeStr(maxImageSize)})!);
      return false;
    }
    return true;
  };

  const handleLoadFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;

    if(files){
      const file: File = files[0];
      if(checkFileFormat(file) && checkFileSize(file)) {
        const url = URL.createObjectURL(file);
        setFile({
          url: url,
          name: file.name,
          file: file,
        })
        setMessage(messageBanner);
        setHasError(false);
      }
      else {
        setHasError(true);
      }
    }
  };

  const handleRemoveFile = () => {
    setMessage(messageBanner);
    setFile(null);
  };

  return (
    <Container style={style}>
      <Header>
        {!file && (
          <>
            <Typography type={isMobile ? "labelS" : "labelL"} color="title">{title}</Typography>
            <FileUploadButton label={t('attach')} id={id} onChange={handleLoadFile} />
          </>
        )}
      </Header>
      <Content>
        { file ? (
          <>
            <FileName>
              <UploadedImage src={file.url} />
              <Typography color={hasError ? "error" : "body"} type="paragraphXS" >{message}</Typography>
            </FileName>
            <ActionsContainer>
              <UploadIcon handleLoadFile={handleLoadFile} idForUploadButton={id}/>
              <DeleteIcon handleRemoveFile={handleRemoveFile}/>
            </ActionsContainer>
          </>
        ): (
          <Typography color={hasError ? "error" : "body"} type="paragraphXS" >{message}</Typography>
        )}
      </Content>
    </Container>
  );
}